export const comments_3278341 = {"data":{"data":[],"links":{}}}